type ResponseHeaders =
  | Record<string, string | string[] | undefined>
  | { get?: (name: string) => string | undefined | null }

export function getContentDispositionFromHeaders(
  headers: ResponseHeaders | undefined | null,
): string {
  if (!headers) return ''

  if (typeof headers.get === 'function') {
    return (
      headers.get('content-disposition')
      ?? headers.get('Content-Disposition')
      ?? ''
    )
  }

  const record = headers as Record<string, string | string[] | undefined>
  const value = record['content-disposition'] ?? record['Content-Disposition']
  if (Array.isArray(value)) {
    return value[0] ?? ''
  }
  return value ?? ''
}

export function parseDownloadFilename(disposition: string | null | undefined, fallback: string): string {
  if (!disposition) return fallback

  const parts = disposition.split(';')

  for (const part of parts) {
    const trimmed = part.trim()
    const starMatch = trimmed.match(/^filename\*=(?:RFC5987|utf-8|UTF-8)''(.+)$/i)
    if (starMatch?.[1]) {
      try {
        return decodeURIComponent(starMatch[1].trim().replace(/\+/g, ' '))
      } catch {
        // fall through
      }
    }
  }

  for (const part of parts) {
    const trimmed = part.trim()
    const quotedMatch = trimmed.match(/^filename="([^"]*)"$/i)
    if (quotedMatch?.[1] && !/^[\?]+$/.test(quotedMatch[1])) {
      return quotedMatch[1]
    }
  }

  for (const part of parts) {
    const trimmed = part.trim()
    const plainMatch = trimmed.match(/^filename=([^;\n]+)$/i)
    if (plainMatch?.[1]) {
      const value = plainMatch[1].trim().replace(/^["']|["']$/g, '')
      if (value && !/^[\?]+$/.test(value)) {
        return value
      }
    }
  }

  return fallback
}
